module.exports = __webpack_public_path__ + "static/three-js-ico-a3fa5e0821ef38ad553b02527f79aa80.png";